<template>
     <div class="coverdetailsbloc">
          <span class="info-title">{{$t('Claim.RequestClaim.SUMMARY_CLAIM_COVER_SUB_TITLE')}}</span>
        <div class="divider">
            <v-divider></v-divider>
        </div>
        <div class="detailsinfoclaim" style="padding-bottom: 22px !important;">
                <span class="sub-title-header">{{$t('Claim.RequestClaim.SUMMARY_FILE_ATTACHMENT_SUB_TITLE')}}</span>
        </div>
        <v-layout v-for="(item, index) in cover.claim.documents" :key="index" row class="submitclaimfilesfield" >
           <span>{{item.fileTitle}}</span>
           <EvidenceList :files="item.files" :claimId="cover.claim.id" :title="item.fileTitle"/>
        </v-layout>
        <v-layout v-if="!userInfos.claimExtendedForm" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_REFERENCE_NUMBER_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.number}}
                </v-flex>
        </v-layout>
         <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.DATE_SUBMISSION_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.createdAt}}
                </v-flex>
        </v-layout>
        <div class="detailsinfoclaim">
                <span class="sub-title-header">{{$t('Claim.ShowClaim.OWNER_SUB_TITLE')}}</span>
        </div>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs12>
                  <div class="claimowner">
                    <span class="color-circle"  v-bind:style="{background:cover.claim.owner.calculatedColor}"><p class="colorName">{{ cover.claim.owner.initials }}</p> </span>
                    <span class="claimownernamebloc">{{ cover.claim.owner.firstName }} {{ cover.claim.owner.lastName }}</span>
                  </div>
                </v-flex>
        </v-layout>
        <ContactDetails :contact="cover.claim.buyerContact" :title="buyerContactTitle" />
        <ContactDetails v-if="userInfos.claimExtendedForm" :contact="cover.claim.sellerContact" :title="sellerContactTitle" />
        <div class="detailsinfoclaim">
                <span class="sub-title-header">{{$t('Claim.RequestClaim.SUMMARY_CONTEXT_INFORMATION_SUB_TITLE')}}</span>
        </div>
        <v-layout v-if="userInfos.claimSettings.showCollectedAmount" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.COLLECTED_AMOUNT_FIELD_NAME')}} :</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.collectedAmount}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.AMOUNT_WITHOUT_VAT_FIELD_NAME')}} :</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.amountWithoutVAT}}
                </v-flex>
        </v-layout>
         <v-layout v-if="userInfos.claimSettings.showDeliveryDate" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>Delivery date :</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.deliveryDate}}
                </v-flex>
        </v-layout>
        <v-layout v-if="userInfos.claimExtendedForm" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.FUNDED_AMOUNT_FIELD_NAME')}} :</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.fundedAmount}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_IS_INVOICE_DISPUTED_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.isDisputed === 'Yes' ? $t('Claim.RequestClaim.SUMMARY_YES_DESC') : $t('Claim.RequestClaim.SUMMARY_NO_DESC')}}
                </v-flex>
        </v-layout>
         <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_IS_BUYER_UNDER_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.isInsolvencyProceeding === 'Yes' ? $t('Claim.RequestClaim.SUMMARY_YES_DESC') : $t('Claim.RequestClaim.SUMMARY_NO_DESC')}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_REFERENCE_NUMBER_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.claim.claimContextInfo.clientReferenceNumber}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_COMMENT_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                  {{cover.claim.claimContextInfo.comment}}
                </v-flex>
        </v-layout>

     </div>
</template>
<script>
import { mapState } from 'vuex'
import EvidenceList from '@/components/cover/claim/EvidenceList'
import ContactDetails from '@/components/cover/claim/ContactDetails'

export default {
  data () {
    return {
      buyerContactTitle: this.$t('Claim.RequestClaim.SUMMARY_BUYER_CONTACT_SUB_TITLE'),
      sellerContactTitle: this.$t('Claim.ShowClaim.SELLER_CONTACT_SUB_TITLE'),
      currency: ''
    }
  },
  computed: {
    ...mapState('cover', ['cover']),
    ...mapState('userdetails', ['userInfos'])
  },
  components: {
    EvidenceList,
    ContactDetails
  }
}
</script>
<style>
.detailsinfoclaim {
    padding-top: 26px;
}
.claimowner{
    display: inline-flex;
}
.claimownernamebloc {
    padding-top: 11px;
    padding-left: 13px;
}
</style>
